import { ClipboardPenLine, Eye, Pencil, Plus, Trash2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import GeneratorForm from "./GeneratorForm";
import { useUser } from "@/app/context/UserContext";
import { Action, ModeLayout, PanelLayout, TypeEnvironment } from "@/app/constants/enums";
import ViewFrm from "./ViewFrm";
import AccordionItem from "../Elements/AccordionItem";
import { getDefaultSchema } from "@/app/constants/defaultValue";
import { iProComponent } from "@/app/models/interfaceProject";
import Accordion from "../Elements/Accordion";
import ButtonChat from "../Elements/Core/ButtonChat";
import ConversationManager, { ConversationManagerRef } from "../Conversation/ConversationManager";
import { useConfig } from "@/app/context/ConfigContext";



export default function DynamicForm() { 
    const { modeLayout, formSchemaJson, setFormSchemaJson,userProject, userProjectLoaded } = useUser(); 
    const { queryParams, baseUrl } = useConfig();
    const [isEditingForm, setIsEditingForm] = useState(true);    
    useEffect(() => {  
        if(userProjectLoaded&&userProject.project.env == TypeEnvironment.Prod){ 
			setIsEditingForm(false);
        } 
    }, []);
    
        // Acordion 
    const [openIndexAcordion, setOpenIndexAcordion] = useState<number | null>(0);
    const handleOpenAcordion = (index: number) => {
        setOpenIndexAcordion(openIndexAcordion === index ? null : index);
    }; 

    const addSchema = () => { 
        setFormSchemaJson([getDefaultSchema(PanelLayout.Left),...formSchemaJson]);
    };

    const delSchema = (item: iProComponent) => {
        setFormSchemaJson((prevState: iProComponent[]) =>
          prevState.map(comp =>
            comp.form_id === item.form_id
              ? { ...comp, deleted: true }
              : comp
          )
        );
      };


    const changeViewEdit = (item: iProComponent, viewEdit: boolean) => {
        setFormSchemaJson((prevState: iProComponent[]) =>
          prevState.map(comp =>
            comp.form_id === item.form_id
              ? { ...comp, view_edit: viewEdit }
              : comp
          )
        );
      };
    
    // conversatio acordion
    const [openAccordionConv, setOpenAccordionConv] = useState<boolean>(true);   
    const convManagerRef = useRef<ConversationManagerRef>(null);
    

    return (
        <div className="flex flex-col w-full space-y-4">
        {isEditingForm && modeLayout==ModeLayout.Edit?
            <>
                <div className="flex items-center justify-between">
                    <h3 className={`text-lg font-bold transition-all duration-500 transform`}>
                    Generar Formulario
                    </h3>
                    
                        <button
                            type="button"
                            onClick={addSchema}
                            className="btn-inca-secondary shadow-md flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 border border-gray-300 hover:bg-gray-200 transition-all duration-500 transform ml-auto"
                        >
                            <Plus className="w-5 h-5" strokeWidth={1.5} />
                        </button>
                    
                    
                </div> 
                {/* Sección de tabs (acordeones) en una sola columna */}
                <div className="flex flex-col w-full space-y-2">
                    {formSchemaJson &&
                    formSchemaJson.filter(O=>!O.deleted).map((item,i) => (
                        <AccordionItem
                            key={item.form_id}
                            title={item.schema.title}
                            index={i}
                            isOpen={openIndexAcordion === i}
                            onClick={() => handleOpenAcordion(i)}
                            className=""
                            >
                                <div className="w-full p-2 py-3"> 
                                        <div className="relative "> 
                                            <button
                                            onClick={() => delSchema(item)}
                                            className={`absolute btn-inca-secondary shadow-md -top-14 right-12 flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 border border-gray-300 hover:bg-gray-200  transition-all duration-500 transform
                                                `}
                                            >
                                                <Trash2 className="w-5 h-5" strokeWidth={1.5} />                    
                                            </button>
                                            <button
                                            onClick={() => changeViewEdit(item,false)}
                                            className={`absolute btn-inca-secondary shadow-md -top-14 right-0 flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 border border-gray-300 hover:bg-gray-200  transition-all duration-500 transform 
                                                ${ item.view_edit ? "opacity-100 scale-100" : "opacity-0 scale-90 pointer-events-none"}`}
                                            >
                                            <Eye  className="w-5 h-5" strokeWidth={1.5} />
                                            </button> 
                                            <button
                                            onClick={() => changeViewEdit(item,true)}
                                            className={`absolute btn-inca-secondary shadow-md -top-14 right-0 flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 border border-gray-300 hover:bg-gray-200  transition-all duration-500 transform
                                                ${item.view_edit ? "opacity-0 scale-90 pointer-events-none" : "opacity-100 scale-100"}`}
                                            >
                                                <Pencil className="w-5 h-5" strokeWidth={1.5} />                    
                                            </button>
                                    </div> 
                                    <div className=" ">
                                        <div
                                            className={`w-full  transition-all duration-500 transform mt-5
                                                ${ item.view_edit ? "opacity-100 scale-100" : "opacity-0 scale-90 pointer-events-none h-0"}`}
                                        > 
                                            <GeneratorForm key={item.form_id+"generator"} vCompoment={item}/> 
                                        </div> 
                                        <div
                                            className={`w-full  transition-all duration-500 transform 
                                                ${item.view_edit ? "opacity-0 scale-90 pointer-events-none h-0" : "opacity-100 scale-100"}`}                    
                                        > 
                                            <ViewFrm key={item.form_id+"view"} formSchema={item.schema} form_id={item.form_id} form={item}/> 
                                        </div> 
                                    </div> 
                                
                                    
                                </div> 
                        </AccordionItem>
                    ))}
                </div>
            </>
        :    
            <div className="flex flex-col w-full space-y-2">
                {formSchemaJson &&
                formSchemaJson.filter(O=>!O.deleted).map((item,i) => (
                    <AccordionItem
                        key={item.form_id}
                        title={item.schema.title}
                        index={i}
                        isOpen={openIndexAcordion === i}
                        onClick={() => handleOpenAcordion(i)}
                        className=""
                        >
                            <div className="w-full p-2 py-3"> 
                                <div className={`w-full  transition-all duration-500 transform`}> 
                                    <ViewFrm key={item.form_id+"view"} formSchema={item.schema} form_id={item.form_id} form={item}/> 
                                </div> 
                            </div> 
                    </AccordionItem>
                ))}

                {/*conversaciones 

                <Accordion
                    title="Conversaciones"
                    index={0}
                    isOpen={openAccordionConv}
                    onClick={()=>setOpenAccordionConv(!openAccordionConv)}
                    classNameHead="border-b py-1"
                    classNameBody="p-1"
                    rightComponent={
                        <div className="flex items-center">
                        <ButtonChat
                            actionCode={Action.LEFT_CONVERSATION_ADD}
                            type="button"
                            onClick={() => convManagerRef.current?.handleAdd()}  
                            className="rounded-full text-blue-700 hover:bg-slate-200 transition duration-150 ease-in-out flex-shrink-0"
                        >
                            <Plus strokeWidth={1} className="m-2" />
                        </ButtonChat>
                        </div>
                    }
                    viewChevron={false}
                    >
                        <ConversationManager ref={convManagerRef} />
                    </Accordion>
                    */ }
            </div>
            
        }
        
 
        </div>

                
                 
        
    );
}
